var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Table } from '../../../components';
import history from '../../../helpers/History';
var DiscountCodesTable = /** @class */ (function (_super) {
    __extends(DiscountCodesTable, _super);
    function DiscountCodesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            history.push("/discountcodes/".concat(value.id));
        };
        _this.handleCreate = function () {
            history.push("/discountcodes/create");
        };
        return _this;
    }
    DiscountCodesTable.prototype.componentDidMount = function () {
        this.props.store.discountCodesStore.read();
    };
    DiscountCodesTable.prototype.render = function () {
        var discountCodesStore = this.props.store.discountCodesStore;
        var filters = [
            {
                name: 'all',
                filter: function (item) { return true; }
            },
            {
                name: 'actives',
                filter: function (item) { return item.disabled_at === null; }
            },
            {
                name: 'disabled',
                filter: function (item) { return item.disabled_at !== null; }
            },
        ];
        var headers = ['code', 'typeDiscount', 'value', 'start', 'expire', 'disabled', 'limitUse'];
        return (React.createElement(Table, { filters: filters, items: discountCodesStore.data, header: headers, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); }, loading: !discountCodesStore.loaded }));
    };
    DiscountCodesTable = __decorate([
        inject('store'),
        observer
    ], DiscountCodesTable);
    return DiscountCodesTable;
}(Component));
export default DiscountCodesTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DiscountCodes/containers/DiscountCodesTable.tsx
// module id = 1615
// module chunks = 0